import { SuggestionProps } from "@tiptap/suggestion";
import { Component, createRef } from "react";
import styles from "./CommandList.module.scss";
import classNames from "classnames";
import Button from "../../../../ui/Button/Button";

class CommandList extends Component<
  SuggestionProps,
  { selectedIndex: number }
> {
  private ref = createRef<HTMLDivElement>();

  state = {
    selectedIndex: 0,
  };

  componentDidUpdate(oldProps: SuggestionProps) {
    if (this.props.items !== oldProps.items) {
      this.setState({
        selectedIndex: 0,
      });
    }
  }

  onKeyDown({ event }: { event: KeyboardEvent }) {
    if (event.key === "ArrowUp") {
      this.upHandler();
      return true;
    }

    if (event.key === "ArrowDown") {
      this.downHandler();
      return true;
    }

    if (event.key === "Enter") {
      this.enterHandler();
      return true;
    }

    return false;
  }

  upHandler() {
    this.setState({
      selectedIndex:
        (this.state.selectedIndex + this.props.items.length - 1) %
        this.props.items.length,
    });
  }

  downHandler() {
    this.setState({
      selectedIndex: (this.state.selectedIndex + 1) % this.props.items.length,
    });
  }

  enterHandler() {
    this.selectItem(this.state.selectedIndex);
  }

  selectItem(index: number) {
    const item: unknown = this.props.items[index];

    if (item) {
      this.props.command(item);
    }
  }

  render() {
    const { items } = this.props;

    return (
      <div className={styles.items} ref={this.ref}>
        {items.map((item, index) => {
          return (
            <Button
              leftIcon={<item.IconComponent />}
              variant="unstyled"
              key={index}
              className={classNames(styles.item, {
                [styles.isSelected]: index === this.state.selectedIndex,
              })}
              onClick={() => this.selectItem(index)}
            >
              {/* eslint-disable-next-line @typescript-eslint/no-unsafe-member-access */}
              {item.element || item.title}
            </Button>
          );
        })}
      </div>
    );
  }
}

export default CommandList;
